import styled from 'styled-components';
import { COLOR_PALETTE } from 'common/colors';
import { LAYERS, SIZE } from 'common/sizes';
import { LABEL } from 'common/base';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const ToolTipContainer = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    margin: 0 ${SIZE.ONE}px;
    z-index: ${LAYERS.LAYER_4};
    white-space:normal;
    &:hover {
        cursor: pointer;
    }
`;

export const ToolTipBox = styled.div`
    position: absolute;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    transition: all 0.25;
    top: 0px;
    left: 0px;
    border-radius: 3px;
    box-shadow: 0 1px 4px 0 rgba(55, 63, 83, 0.51);
    border: solid 1px #d3d8db;
    
    visibility: hidden;
    opacity: 0;
    background-color: ${(props: any) => `${props.background?props.background:`#ffffff`}`};;
    border-radius: ${SIZE.TEN}px;
    padding: ${SIZE.ONE}px;
    transition: all .3s;
    &:hover {
        
    }

    
`;

export const ToolTipTextContainer = styled.div`
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    flex: 0 0 auto;
    visibility: hidden;
    opacity: 0;
`

export interface ToolTipProps {
    left: string
    top: string
    background?: string
}

export const HoverableElement = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    &:hover ${ToolTipTextContainer} {
        visibility: visible;
        opacity: 1;
        transition-delay: .3s;
    };
    &:hover > ${ToolTipBox} {
        visibility: visible;
        overflow: auto;
        flex-flow: column;
        transition: all .3s ease-out;
        border-radius: ${SIZE.QUART}px;
        opacity: 1;
        max-height:${SIZE.TWENTYFIVE}px;
        ${(props: any) => `transform: translate(${props.left}, ${props.top})`};
    }
`;

export const ToolTipIcon = styled(HoverableElement)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 15px;
    width: ${SIZE.TWO}px;
    height: ${SIZE.TWO}px;
    transition: all .3s ease-out;
    &::before {
        content: ${(props: { top: string, iconCode: string }) => `"\\${props.iconCode}"`};
        font-family: 'icomoon' !important;
        color: ${COLOR_PALETTE.CHASSIS_GRAY};
    }
`;

export const IconContainer = styled(HoverableElement)`
    width: 16px;
    height: 15px;
    color: #ffff;
    font-size: 14px;
    padding-top: 1px;
    &:hover {
        transform: scale(1.2);
        cursor: default;
    };
    transition: all 0.300s;
`;

export const QuestionMark = styled(IconContainer)`
    background-color: #373f53;
`;



export const ToolTipLabel = styled(LABEL)`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    color: #373f53;
`

export const ToolTipTitle = styled(ToolTipLabel)`
    height: ${SIZE.THREE}px;
    font-size: 12px;    
    line-height: 1;
    letter-spacing: 0.43px;
    align-items: center;

`;

export const ToolTipBody = styled(ToolTipLabel)`
    font-family: ${DEFAULT_FONT_FAMILY}
    font-size: 12px;
    line-height: 1.2;
    letter-spacing: 0.36px;
    flex: 1;
    
`;